@use "~@nwi/style-core/variables/color" as *;

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:host {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .rotation-wrapper {
    margin-top: -8%;
    justify-content: center;
    display: flex;
  }

  .images-container {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    min-height: 120px;
    padding-bottom: 56%;
    cursor: grab;

    &:active:hover {
      cursor: grabbing;
    }

   .image-wrapper {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      opacity: 0;

      &.active {
        z-index: 3;
        opacity: 1;
      }

      > img,
      > fading-image > img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .circle-container {
    position: absolute;
    bottom: 50%;
    z-index: 3;
    pointer-events: none;
    display: flex;
    width: 150px;
    height: 62px;
    background: white;
    border-radius: 31px;
    align-items: center;
    opacity: 1;
    transition: opacity 0.6s ease-in;

    &.hidden {
      opacity: 0;
    }

    .circle {
      width: 100%;
      height: 100%;
    }

    .prev-icon,
    .next-icon {
      padding: 10px;
      user-select: none;
      position: absolute;
    }

    .prev-icon {
      left: 10px;
    }

    .next-icon {
      right: 10px;
    }

    .drag-btn-anim {
      animation: drag-btn-anim 1.3s ease-in-out infinite;
    }

    @keyframes drag-btn-anim {
      0% {
        transform: translateX(25%);
        opacity: 1;
      }
      50% {
        transform: translateX(-0%);
        opacity: 1;
      }
      100% {
        transform: translateX(-0%);
        opacity: 0;
      }
    }

    .drag-btn-anim-inverted {
      animation: drag-btn-anim-inverted 1.3s ease-in-out infinite;
    }

    @keyframes drag-btn-anim-inverted {
      0% {
        transform: translateX(-25%);
        opacity: 1;
      }
      50% {
        transform: translateX(0%);
        opacity: 1;
      }
      100% {
        transform: translateX(0%);
        opacity: 0;
      }
    }
  }

  .fallback {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    .fallback-image {
      width: 100%;
      height: 100%;
    }
  }

  #nwi-root {
    &.SM {
      .rotation-wrapper {
        margin-top: -11%;
      }
    }

    &.VW19 {
      .rotation-wrapper {
        margin-bottom: -10%;
      }
      &.SM {
        .rotation-wrapper {
          margin-top: -9%;
        }
      }
    }
    &.LNF19 {
      .rotation-wrapper {
        margin-top: -7%;
      }
      &.SM {
        .rotation-wrapper {
          margin-top: -5%;
        }
      }
    }
  }
}
